import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type { Registry as ServiceRegistry } from '@ember/service';

interface PhoneVerificationQueryParams {
    jwt: string | null;
}

/**
 * @classdesc Route for guest checkout phone verification SGT3 page.
 */
export default class PhoneVerificationGuestCheckoutRoute extends Route {
    @service declare store: ServiceRegistry['store'];

    queryParams = {
        jwt: {
            refreshModel: true
        }
    };

    /**
     * Returns model for new guest phone verification.
     *
     * @returns {{phoneVerificationGuest: (models.PhoneVerificationGuest|promise)}}
     */
    async model(params: PhoneVerificationQueryParams) {
        try {
            const phoneVerificationGuest = this.store.createRecord(
                'phone-verification-guest'
            );

            phoneVerificationGuest.set('jwt', params.jwt);

            return { phoneVerificationGuest };
        } catch (error) {
            this.send('error', error);

            return {};
        }
    }
}
